export enum Colors {
  BlackOpaque = "rgba(0,0,0,0.8)",
  Primary = "rgba(204, 73, 40, 1)",
  PrimaryDark = "rgba(181, 45, 11, 1)",
  Loading = "rgba(255,255,255,0.20)",
  Secondary = "rgba(255,255,255,1)",
  WhiteOpaque = "rgba(255,255,255,0.95)",
}
